import Login from "../Login";

/**
 *
 * @returns receives the request to process the QR code.  Accepts the encrypted code, then forwards to login page for further processing
 */
const Checkin = () => {
  return <Login checkin="true" />;
};

export default Checkin;
